export default "<h5 [ngClass]=\"class\">{{title}}</h5>\n"